<!--  从首页跳转到该页面 校友认证成功页面 提示补全个人信息 code=411
  同时login页面当code=411 跳转自动匹配/人工审核通过 但未填写身份证 该页面-->
<template>
    <div>
        <div>
            <img class="failImg" src="./images/btn_chenggong_nor@2x.png" alt="" srcset="">
            <div class="com-text short-text">恭喜您，校友身份认证成功</div>
        </div>
        <div class="com-text short-text">请补全您的个人信息</div>
        <el-button style="display: block; margin-top: 30px;" class="lwork" type="primary" @click="contact">补全个人信息</el-button>
        <!-- <el-button style="display: block; margin-top: 30px;" class="lwork" type="primary" @click="skipToIndex">去首页</el-button> -->
    </div>
</template>

<script>
export default {
  data(){
    return{
      userId: localStorage.getItem('user_id'),
      // alumnus_id: '',
      isWriteIdCard: false,
      idcard: ''
    }
  },
  created() {
    // this.getAlumniId()
    if (this.$route.query.isWriteIdCard) this.isWriteIdCard = true
    this.idcard = (this.$route.query.idcard || '').trim()
  },
  methods:{
    contact(){
      this.$router.push({
        path: "/completePersonInfo",
        query: {
          idcard: this.idcard,
        },
      })
    },
    skipToIndex() {
      this.$router.push('/index')
    },
  },
}
</script>

<style lang="less" scoped>
.com-text{
    margin: 10px auto;
    text-align: center;
    color: #333333;
}
.short-text{
    font-size: 20px;
}
.el-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    margin: auto;
}
.el-button+.el-button {
    margin: auto;
}
.long-text{
    width: 80%;
    margin: 50px auto;
    color: #333333;
    font-size: 16px;
}
.lwork{
    width: 80%;
    background-color: #00706E;
    height: 35px;
    line-height: 35px;
    font-size: 20px;
    color: #fff;
    margin: 0 auto;
    border-radius: 35px;
    padding: 0;
}
.failImg{
    border-radius: 50%;
    height: 200px;
    width: 250px;
    border-radius: 50%;
    display: block;
    margin: 25px auto;
}
.hwork{
    color: #333333;
    margin: 15px auto;
    text-align: center;
    width: 80%;
}
.el-button+.el-button{
    margin-left: 9%;
}
</style>



// WEBPACK FOOTER //
// src/components/IdentitAuthentication/idSucess.vue